import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { Grid, Form } from 'semantic-ui-react';
import { Field, reduxForm } from 'redux-form';
import moment from 'moment';

import { MASTER_ROSTER_FORM_NAME } from 'Common/FormEnum';
import { TitledCard } from 'Components/';
import { SelectField, DatePickerField } from 'Common/SemanticWrapper';
import {
  MasterRosterFieldEnum as Fields,
  ReportFieldEnum as ReportFields,
} from 'Common/FieldEnum';
import {
  sortByOptions,
  statusOptions,
  caseTypeOptions,
  statusFilterMethods,
  asOfOptions,
  provisionTypeOptions,
  filterMethodEnums,
} from '../helpers/constants';
import { SiteComponent } from 'Common/SiteComponent';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { YesNoOptions } from 'Common/FormHelper';
import { ReportFormatButtonGroup } from 'Components/forms/ReportFormatButtonGroup';

class MasterRosterFormContainer extends Component {
  static propTypes = {
    statusFilterMethod: PropTypes.string,
    grades: PropTypes.array,
    releaseCategories: PropTypes.array,
  };

  render() {
    return (
      <Fragment>
        <Form name={MASTER_ROSTER_FORM_NAME}>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <TitledCard title={'As Of'}>
                  <Grid.Column>
                    <Grid.Row style={{ height: '75px' }}>
                      <Field
                        name={Fields.ReportDT}
                        component={DatePickerField}
                        maxDate={moment()}
                        type="text"
                      />
                    </Grid.Row>
                    <Grid.Row className="input-group--btn-group">
                      <ReduxFormButtonGroup
                        formName={MASTER_ROSTER_FORM_NAME}
                        options={asOfOptions}
                        fieldName={Fields.UseAppDate}
                      />
                    </Grid.Row>
                  </Grid.Column>
                </TitledCard>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Grid doubling columns={2}>
            <Grid.Column width={9}>
              <TitledCard title={'Filter By'}>
                <Grid.Row>
                  <Grid.Column className="input-group--btn-group">
                    <ReduxFormButtonGroup
                      formName={MASTER_ROSTER_FORM_NAME}
                      options={statusFilterMethods}
                      fieldName={Fields.StatusFilterMethod}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    {this.props.statusFilterMethod ===
                      filterMethodEnums.status && (
                      <Field
                        multiple
                        selectAllButton
                        selectNoneButton
                        label={'Statuses'}
                        component={SelectField}
                        name={Fields.Statuses}
                        options={statusOptions}
                      />
                    )}
                    {this.props.statusFilterMethod ===
                      filterMethodEnums.caseType && (
                      <Field
                        label={'Other Options'}
                        component={SelectField}
                        name={Fields.FilterOnly}
                        options={caseTypeOptions}
                      />
                    )}
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    <SiteComponent
                      name={Fields.SiteId}
                      {...this.props}
                      isForm={true}
                      isAllRequired={true}
                      fetchAllSites={true}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    <Field
                      label={'Grade'}
                      component={SelectField}
                      name={Fields.GradeId}
                      options={this.props.grades}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    <Field
                      className={'shorter'}
                      label={'Release Category'}
                      component={SelectField}
                      name={Fields.ReleaseCategory}
                      options={this.props.releaseCategories}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column className="input-group--btn-group">
                    <ReduxFormButtonGroup
                      label={'Provison Type'}
                      formName={MASTER_ROSTER_FORM_NAME}
                      fieldName={Fields.ProvisionType}
                      options={provisionTypeOptions}
                    />
                  </Grid.Column>
                </Grid.Row>
              </TitledCard>
            </Grid.Column>
            <Grid.Column width={7}>
              <Grid.Row>
                <Grid.Column>
                  <TitledCard title={'Sort By'}>
                    <Grid.Row>
                      <Grid.Column>
                        <Field
                          component={SelectField}
                          name={Fields.SortBy}
                          options={sortByOptions}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </TitledCard>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <TitledCard title={'Show SSN'}>
                    <Grid.Row>
                      <Grid.Column>
                        <ReduxFormButtonGroup
                          formName={MASTER_ROSTER_FORM_NAME}
                          fieldName={Fields.ShowSSN}
                          options={YesNoOptions}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </TitledCard>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <TitledCard title={'Report Format'}>
                    <Grid.Row>
                      <Grid.Column>
                        <ReportFormatButtonGroup
                          formName={MASTER_ROSTER_FORM_NAME}
                          fieldName={ReportFields.ReportFormat}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </TitledCard>
                </Grid.Column>
              </Grid.Row>
            </Grid.Column>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const validate = (values) => {
  var errors = [];
  if (!values[Fields.SiteId]) {
    errors[Fields.SiteId] = 'Site must be set.';
  }

  if (!moment(values[Fields.ReportDT]).isValid()) {
    errors[Fields.ReportDT] = 'Enter a valid Date.';
  }

  if (
    values[Fields.StatusFilterMethod] === filterMethodEnums.status &&
    !values[Fields.Statuses].length
  ) {
    errors[Fields.Statuses] = 'Choose a status.';
  }

  if (
    values[Fields.StatusFilterMethod] === filterMethodEnums.caseType &&
    !values[Fields.FilterOnly]
  ) {
    errors[Fields.FilterOnly] = 'Choose a case type.';
  }

  return errors;
};

const MasterRosterForm = reduxForm({
  form: MASTER_ROSTER_FORM_NAME,
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(withRouter(MasterRosterFormContainer));

export { MasterRosterForm };



// WEBPACK FOOTER //
// ./src/pages/masterroster/components/MasterRosterForm.js